import React from 'react';
import VisualisationsToolboxAbstract from '../VisualisationsToolboxAbstract';
import AggregateJourneyMap from '../../components/analysis/visualisations/AggregateJourneyMap';

class AggregateJourneymapToolbox extends VisualisationsToolboxAbstract {
  static addParams(unit) {
    return {
      id: unit.file,
      ct: 'csv'
    };
  }

  static canProcess(nextProps) {
    return true;
  }

  static getVisualisationComponent(props) {
    if (!props.aggregateJourneyMap) {
      throw new TypeError('Missing Aggregate JourneyMap prop');
    }
    return <AggregateJourneyMap key={0} journeyMap={props.aggregateJourneyMap} />;
  }

  static getProcessButtonLabel() {
    return 'Process the Aggregate Journey Map';
  }

  static getBlockParameters() {
    return {
      windowdStep: 1,
      windowdSize: 2,
      extract: true
    };
  }
}

export default AggregateJourneymapToolbox;



// WEBPACK FOOTER //
// ./src/scenes/analysis/lib/visualisationTypes/AggregateJourneymapToolbox.js